import { fromJS } from 'immutable';
import requestStatusType from '../constants/requestStatusTypes';
import { getTags } from '../api/tagsApi';
import { createSelector } from 'reselect';
const {
  UNINITIALIZED,
  PENDING,
  SUCCEEDED,
  FAILED
} = requestStatusType;
export const tagsNamespace = 'tags';

// Action types
const GET_TAGS_PENDING = 'GET_TAGS_PENDING';
const GET_TAGS_SUCCEEDED = 'GET_TAGS_SUCCEEDED';
const GET_TAGS_FAILED = 'GET_TAGS_FAILED';
// Actions
export const fetchTags = () => dispatch => {
  dispatch({
    type: GET_TAGS_PENDING
  });
  return getTags().then(response => {
    dispatch({
      type: GET_TAGS_SUCCEEDED,
      payload: response
    });
  }, error => {
    console.error(error); // eslint-disable-line no-console
    dispatch({
      type: GET_TAGS_FAILED,
      payload: error
    });
  });
};
// Reducers
const initialState = fromJS({
  status: UNINITIALIZED,
  tags: []
});
export const tagsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TAGS_PENDING:
      return state.set('status', PENDING);
    case GET_TAGS_SUCCEEDED:
      return state.set('status', SUCCEEDED).set('tags', action.payload);
    case GET_TAGS_FAILED:
      return state.set('status', FAILED);
    default:
      return state;
  }
};

// Selectors
export const selectTagsRoot = state => state[tagsNamespace];
export const selectTags = createSelector(selectTagsRoot, tagsRoot => tagsRoot === null || tagsRoot === void 0 ? void 0 : tagsRoot.get('tags'));
export const selectTagsStatus = createSelector(selectTagsRoot, tagsRoot => tagsRoot === null || tagsRoot === void 0 ? void 0 : tagsRoot.get('status'));